<rt-message variant="context-warning">
  <div layout-horizontal>
    @if (!compact()) {
      <rt-icon
        name="info"
        size="medium"
        colorToken="colorIconWarningDefault"
        margin-right-small-x
      />
    }

    <p [attr.text-center]="compact()">
      {{ altMessage() || message }}
      <span class="cta-text" (click)="manageOffers()">
        {{ 'app.pricing.job_slots_dialog.slots_downgrade_limit_cta' | translate }}
      </span>
    </p>
  </div>
</rt-message>
